import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const isSupport = () => {
  try {
    return "Notification" in window && "serviceWorker" in navigator && "PushManager" in window;
  } catch (error) {
    console.log("Browser tidak mendukung notifikasi: ", error);
    return false;
  }
};

const firebaseConfig = {
  apiKey: "AIzaSyB9oBhc_QJpswT5nHLxuYg-3dKvZSpueKI",
  authDomain: "caready-mobile-88248.firebaseapp.com",
  projectId: "caready-mobile-88248",
  storageBucket: "caready-mobile-88248.appspot.com",
  messagingSenderId: "738493044320",
  appId: "1:738493044320:web:2c24dc9303a78c195ad505",
  measurementId: "G-9CLRB9QLGJ",
};

const app = initializeApp(firebaseConfig);

let messaging = null;
try {
  if (isSupport()) {
    messaging = getMessaging(app);
  }
} catch (error) {
  console.log("Browser tidak mendukung Firebase Messaging: ", error);
}

export const requestForToken = async () => {
  let currentToken = "";
  if (!messaging) {
    console.log("Firebase Messaging tidak didukung di browser ini.");
    return currentToken;
  }

  try {
    // Pastikan service worker sudah siap sebelum request token
    let registration;
    if ("serviceWorker" in navigator) {
      registration = await navigator.serviceWorker.ready;
      console.log("Service Worker sudah siap:", registration);
    }

    // Validasi VAPID key
    const vapidKey = process.env.REACT_APP_VAPID_KEY;
    if (!vapidKey) {
      console.error("VAPID key tidak ditemukan di environment variables");
      return currentToken;
    }

    // Pass registration to getToken to avoid "no active Service Worker" error
    currentToken = await getToken(messaging, {
      vapidKey,
      serviceWorkerRegistration: registration,
    });

    if (currentToken) {
      console.log("[LOG] => FCM Token berhasil didapatkan:", currentToken.substring(0, 20) + "...");
    } else {
      console.log("Tidak ada FCM token yang tersedia. Pastikan permission sudah granted dan service worker terdaftar.");
    }
  } catch (error) {
    console.error("Terjadi kesalahan saat mengambil token: ", error);
    // Log detail error untuk debugging
    if (error.code === "messaging/permission-blocked") {
      console.error("Permission notifikasi diblokir oleh user");
    } else if (error.code === "messaging/registration-token-not-registered") {
      console.error("Service worker belum terdaftar dengan benar");
    }
  }
  return currentToken;
};

export const requestPermission = async () => {
  if (!isSupport()) {
    console.log("Notifikasi tidak didukung di browser ini.");
    return "denied";
  }

  try {
    return await Notification.requestPermission();
  } catch (error) {
    console.log("Kesalahan saat meminta izin notifikasi: ", error);
    return "denied";
  }
};

export const onMessageListener = (callback) => {
  if (!messaging) {
    console.log("Firebase Messaging tidak didukung di browser ini.");
    return () => {}; // Return empty unsubscribe function
  }

  try {
    // onMessage returns an unsubscribe function
    const unsubscribe = onMessage(messaging, (payload) => {
      console.log("Pesan diterima saat aplikasi aktif:", payload);
      if (callback) {
        callback(payload);
      }
    });
    return unsubscribe;
  } catch (error) {
    console.log("Kesalahan saat menerima pesan: ", error);
    return () => {};
  }
};
